import React from "react";
import Header from "../../../components/Headers/Header";
import jsBody from "../../../assets/Tech-Page-Assets/js-body.png";
import reactBody from "../../../assets/Tech-Page-Assets/react-body.png";
import htmlBody from "../../../assets/Tech-Page-Assets/html-body.png";
import phpBody from "../../../assets/Tech-Page-Assets/php-body.png";
import nodeBody from "../../../assets/Tech-Page-Assets/node-body.png";
import sanityBody from "../../../assets/Tech-Page-Assets/sanity-body.png";
import expressBody from "../../../assets/Tech-Page-Assets/express-body.png";
import tailwindBody from "../../../assets/Tech-Page-Assets/tailwind-body.png";
import mongoBody from "../../../assets/Tech-Page-Assets/mongo-body.png";
import mysqlBody from "../../../assets/Tech-Page-Assets/mysql-body.png";

const techs = [
  {
    id: 1,
    class1: "jScriptSection",
    class2: "reactSection",
    title1: "JavaScript",
    title2: "React",
    image1: jsBody,
    image2: reactBody,
    content1:
      "JavaScript is a versatile programming language primarily used for building interactive and dynamic web pages. It is supported by all major web browsers, making it an essential tool for front-end and back-end development. We leverage JavaScript to enhance user interfaces, create dynamic web content, and facilitate client-side interactions in web applications.",
    content2:
      "React is a JavaScript library for building user interfaces, developed by Facebook. It allows developers to create reusable UI components that efficiently update in response to data changes. React is a core technology for our front-end development. We build modular and responsive user interfaces, ensuring a seamless and engaging user experience.",
  },
  {
    id: 2,
    class1: "htmlSection",
    class2: "phpSection",
    title1: "HTML/CSS",
    title2: "PHP",
    image1: htmlBody,
    image2: phpBody,
    content1:
      "HTML (HyperText Markup Language) and CSS (Cascading Style Sheets) are fundamental technologies for building web pages. HTML structures the content, while CSS styles and formats it. We use HTML/CSS to create the foundational structure and visual design of web applications, ensuring a clean and visually appealing layout.",
    content2:
      "PHP is a server-side scripting language designed for web development. It is widely used for building dynamic web pages and interacting with databases. PHP is a key technology in our back-end development, handling server-side logic, processing forms and managing database interactions.",
  },
  {
    id: 3,
    class1: "nodeSection",
    class2: "sanitySection",
    title1: "Node.js",
    title2: "Sanity",
    image1: nodeBody,
    image2: sanityBody,
    content1:
      "Node.js is a JavaScript runtime environment that enables server-side execution of JavaScript code. It is known for its scalability and efficiency in handling concurrent requests. We use Node.js to build scalable and high-performance server-side applications, handling asynchronous tasks and optimizing real-time interactions.",
    content2:
      "Sanity is a headless content management system (CMS) that allows for flexible content modeling and efficient content delivery through APIs. We utilize Sanity to empower clients with a content management system that provides flexibility in managing and delivering content across various platforms.",
  },
  {
    id: 4,
    class1: "expressSection",
    class2: "tailwindSection",
    title1: "Express.js",
    title2: "Tailwind CSS",
    image1: expressBody,
    image2: tailwindBody,
    content1:
      "Express.js is a web application framework for Node.js, simplifying the process of building robust and scalable server-side applications. Express.js is instrumental in creating RESTful APIs and handling server-side routing, enhancing the efficiency and performance of our applications.",
    content2:
      "Tailwind CSS is a utility-first CSS framework that streamlines the styling process by providing a set of pre-defined classes. We adopt Tailwind CSS to expedite the styling process, ensuring consistency and rapid development while maintaining a clean and maintainable codebase.",
  },
  {
    id: 5,
    class1: "mongoSection",
    class2: "mysqlSection",
    title1: "MongoDB",
    title2: "MySQL",
    image1: mongoBody,
    image2: mysqlBody,
    content1:
      "MongoDB is a NoSQL database that stores data in a flexible, JSON-like format. It is designed for scalability and can handle large amounts of unstructured data. MongoDB is our preferred database solution for applications requiring flexibility in data models and scalability, allowing us to efficiently store and retrieve data.",
    content2:
      "MySQL is a relational database management system (RDBMS) that uses structured query language (SQL). It is widely used for managing structured data. MySQL is employed in scenarios where relational databases are preferred, providing a robust solution for managing structured data in our applications.",
  },
];

const Technologies = () => {
  return (
    <div className="tech-block">
      {techs.map((tech) => (
        <div key={tech.id} className="techs">
          <div className={tech.class1}>
            <Header headerTitle={tech.title1} />
            <div className="container">
              <div className="body1">
                <div className="body-text">
                  <p>{tech.content1}</p>
                </div>
                <div className="body-image">
                  <img src={tech.image1} alt={tech.title2} />
                </div>
              </div>
            </div>
          </div>
          <div className={tech.class2}>
            <Header headerTitle={tech.title2} />
            <div className="container">
              <div className="body2">
                <div className="body-image">
                  <img src={tech.image2} alt={tech.title2} />
                </div>
                <div className="body-text">
                  <p>{tech.content2}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Technologies;
